import {PartnerContactModel} from '../partnerContact.model';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../../common/api/converter/partnerSummary.converter';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {ValueAndLabelConverter} from '../../../../../../common/converter/ValueAndLabel.converter';
import {Injectable} from '@angular/core';
import {
    WorkflowTaskSummaryConverter
} from '../../../../../../workflow/task/api/model/common/converter/workflowTaskSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class PartnerContactConverter extends HttpModelConverter<PartnerContactModel> {
    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private workflowTaskSummaryConverter: WorkflowTaskSummaryConverter,
                private valueAndLabelConverter: ValueAndLabelConverter,
                private partnerSummaryConverter: PartnerSummaryConverter) {
        super();
    }
    protected createInstance(): PartnerContactModel {
        return new PartnerContactModel();
    }

    protected enrichObject(result: PartnerContactModel, src: PartnerContactModel) {
        result.direction = this.valueAndLabelConverter.convert(src.direction);
        result.mode = this.valueAndLabelConverter.convert(src.mode);
        result.otherInvolvedPartner = this.partnerSummaryConverter.convert(src.otherInvolvedPartner);
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.email = this.workflowTaskSummaryConverter.convert(src.email);
    }
}
